<div class="container-fluid not-found-page container-fluid-margin-top-80">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 left-section">
      <div class="heading-semi-bold font-size-38">
        {{ 'not-found-page.title' | translate }}
      </div>
      <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 heading-light font-size-38 padding-null margin-bottom-20"
        style="line-height:1">
        {{ 'not-found-page.caption' | translate }}
      </div>
      <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null margin-bottom-5"
        [innerHtml]="('not-found-page.description' | translate)">
      </div>

      <div *ngIf="countryCode === 'ID'" style="color:#4a4a4a">
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/career">
          {{ 'navigation.career' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/tentang-kami">
          {{ 'navigation.about-us' | translate }}
        </a>
        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null">
          <a routerLink="/log-in">{{ 'navigation.log-in' | translate }}</a> /
          <a routerLink="/sign-up">{{ 'navigation.sign-up' | translate }}</a>
        </div>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/pinjaman-online">
          {{ 'navigation.borrow' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" routerLink="/invest">
          {{ 'navigation.investor' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" routerLink="/refer">
          {{ 'navigation.refer' | translate }}
        </a>
      </div>

      <div *ngIf="countryCode === 'SG'" style="color:#4a4a4a">
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/career">
          {{ 'navigation.career' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/about-us">
          {{ 'navigation.about-us' | translate }}
        </a>
        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null">
          <a routerLink="/log-in">{{ 'navigation.log-in' | translate }}</a> /
          <a href="/sign-up">{{ 'navigation.sign-up' | translate }}</a>
        </div>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/sme-loans">
          {{ 'navigation.borrow' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/investment">
          {{ 'navigation.investor' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/refer">
          {{ 'navigation.refer' | translate }}
        </a>
      </div>

      <div *ngIf="countryCode === 'MY'" style="color:#4a4a4a">
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/career">
          {{ 'navigation.career' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/about-us">
          {{ 'navigation.about-us' | translate }}
        </a>
        <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null">
          <a routerLink="/log-in">{{ 'navigation.log-in' | translate }}</a> /
          <a href="/sign-up">{{ 'navigation.sign-up' | translate }}</a>
        </div>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/sme-financing">
          {{ 'navigation.borrow' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/invest">
          {{ 'navigation.investor' | translate }}
        </a>
        <a class="col-xs-12 col-sm-10 col-md-10 col-lg-10 padding-null" href="/refer">
          {{ 'navigation.refer' | translate }}
        </a>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
      <div class="not-found-page-image"></div>
    </div>
  </div>
</div>
